import { useAtomValue } from 'jotai';
import { CtaForm } from '@pairy/sheard/types';

import useHandleResizedImage from '../../../../hooks/useHandleResizedImage';
import MessageBoxLayer from '../../../@common/Layer/MessageBoxLayer';
import DesktopHyperLinkLayer from '../../../@common/Layer/HyperLinkLayer/Desktop';
import { MessageBoxItemType } from '../../../PdfViewer/index.types';
import { currentPageAtom } from '../../../../store/index.atom';
import { BulkFileType } from '../../../../types/file';

interface Props {
  isPreview?: boolean;
  thumbnails: BulkFileType['thumbnails'];
  ctaForm?: CtaForm;
  messageBoxItems?: MessageBoxItemType[];
  isFormSubmitted?: boolean;
}

const AnnotationLayer = ({
  isPreview = false,
  thumbnails,
  ctaForm,
  messageBoxItems,
  isFormSubmitted,
}: Props) => {
  const currentPage = useAtomValue(currentPageAtom);
  const blindMode = ctaForm?.blind;

  const { hyperlink, originalHeight, originalWidth } =
    thumbnails[currentPage - 1];

  const { resizedImageSize } = useHandleResizedImage({
    originalWidth,
    originalHeight,
  });

  const getFormNotSubmitPage = (moveTargetPage: number) => {
    if (
      !isFormSubmitted &&
      blindMode === 'startFrom' &&
      ctaForm?.page &&
      moveTargetPage >= ctaForm?.page
    ) {
      return ctaForm.page;
    }
    return null;
  };

  return (
    <>
      <MessageBoxLayer
        resizedImageSize={resizedImageSize}
        isPreview={isPreview}
        messageBoxItems={messageBoxItems}
        getFormNotSubmitPage={getFormNotSubmitPage}
      />
      <DesktopHyperLinkLayer
        hyperlinkList={hyperlink}
        resizedImageSize={resizedImageSize}
        isPreview={isPreview}
        getFormNotSubmitPage={getFormNotSubmitPage}
      />
    </>
  );
};

export default AnnotationLayer;
